import { TxStatus } from '@orionprotocol/sdk';

export const isResendableTx = (tx: {
  status?: TxStatus | undefined;
}): boolean => {
  // Exclude final statuses
  if (tx.status === TxStatus.SETTLED || tx.status === TxStatus.FAILED)
    return false;
  // Exclude pending statuses
  if (tx.status === TxStatus.PENDING || tx.status === TxStatus.GAS_ESTIMATING)
    return false;
  // Exclude queued statuses
  if (tx.status === TxStatus.QUEUED || tx.status === TxStatus.SIGNING)
    return false;

  return true;
};
